import styled from "@emotion/styled";
import React from "react";
import { formatPhone } from "../phone_number";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { AppButton } from "./Generic/AppButton";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";
import { AppList, AppListItem } from "./Generic/AppList";

type Props = {
  title: string;
  contacts: {
    name: string;
    e164: string;
  }[];
  onClickCall: (contact: { name: string; e164: string }) => void;
};

export default function ContactsListCard(props: Props) {
  return (
    <AppCard>
      <AppCardHeader>
        <AppCardTitle>{props.title}</AppCardTitle>
      </AppCardHeader>
      <AppCardContent>
        <AppList>
          {props.contacts.map((contact, index) => (
            <AppListItem
              key={index}
              bulletNumber={index + 1}
              title={
                <ContactRoot>
                  <ContactName>{contact.name}</ContactName>
                  <ContactPhoneNumber>{formatPhone(contact.e164)}</ContactPhoneNumber>
                </ContactRoot>
              }
              trailing={
                <AppButton
                  variant="outline"
                  size="small"
                  onClick={() => props.onClickCall(contact)}
                >
                  {translate(STRINGS.CALL)}
                </AppButton>
              }
            />
          ))}
        </AppList>
      </AppCardContent>
    </AppCard>
  );
}

const ContactRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContactName = styled.div`
  font-weight: 600;
`;

const ContactPhoneNumber = styled.div`
  color: var(--tw-slate-600);
`;
